module.exports = __webpack_public_path__ + "img/Job_banner.29c952e2.png";